import React, { forwardRef, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import Paging from '../../../interfaces/common/paging';
import { fetchCancellationRuleSets, getCancellationRuleSets, isLoadingCancellationRuleSets } from '../../../reducers/cancellationRuleSetReducer';
import PageUtils from '../../../utils/pageUtils';
import CancellationRuleSetFilter from '../../../interfaces/filters/cancellationRuleSetFilter';
import WorkflowUtils from '../../../utils/workflowUtils';
import QuickSearchToolbar from '../../common/quickSearchToolbar';
import CancellationRuleSetList from '../cancellationRuleSet/cancellationRuleSetList';

interface AddCustomerCancellationRuleSetStep1Props {
    customerCancellationRuleSet: number | undefined;
    onChange: any;
}

const AddCustomerCancellationRuleSetStep1 = forwardRef((props: AddCustomerCancellationRuleSetStep1Props, ref: any): JSX.Element => {
    const { onChange } = props;
    const [paging, setPaging] = React.useState<Paging>(PageUtils.getDefaultPaging());
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const cancellationRuleSets = useSelector(getCancellationRuleSets);
    const propsIsLoadingCancellationRuleSets = useSelector(isLoadingCancellationRuleSets);
    useEffect(() => {
        dispatch(fetchCancellationRuleSets({
            paging,
            filters: { } as CancellationRuleSetFilter
        }));
    }, [dispatch]);
    WorkflowUtils.setHandle(ref, null);
    const [sortModel, setSortModel] = React.useState<GridSortModel>([{
        field: '',
        sort: '' as GridSortDirection
    } as GridSortItem]);
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState<GridColumnVisibilityModel>({ });

    const _onSortModelChange = (newModel: GridSortModel) => {

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newServerPagination = {
                ...paging,
                sort: newModel
            };

            dispatch(fetchCancellationRuleSets({
                paging: newServerPagination,
                filters: {
                    name: searchTerm
                } as CancellationRuleSetFilter
            }));

            setPaging(newServerPagination);
            setSortModel(newModel);
        }
    };

    return (
        <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
                <QuickSearchToolbar searchTerm={searchTerm} onSearch={(searchTerm: string) => {
                    setSearchTerm(searchTerm);
                    dispatch(fetchCancellationRuleSets({
                        paging: paging,
                        filters: {
                            name: searchTerm
                        } as CancellationRuleSetFilter
                    }));
                }
                }
                />
            </Grid>
            <Grid item xs={12}>
                <CancellationRuleSetList
                    isLoading={propsIsLoadingCancellationRuleSets}
                    rows={cancellationRuleSets}
                    componentsProps={{
                        toolbar: {
                            value: searchTerm,
                            onChange: (event: any) => setSearchTerm(event.target.value),
                            clearSearch: () => setSearchTerm('')
                        }
                    }}
                    disableLinks
                    checkSelection={(value: number) => onChange(value)}
                    onPageChange={(nextPage: number, nextSize: number) => {
                        const newPage = {
                            ...paging,
                            page: nextPage,
                            size: nextSize
                        };
                        dispatch(fetchCancellationRuleSets({
                            paging: newPage,
                            filters: {
                                name: searchTerm
                            } as CancellationRuleSetFilter
                        }));
                        setPaging(newPage);
                    }}
                    onSortModelChange={(sortModel: GridSortModel) => _onSortModelChange(sortModel)}
                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Grid>
        </Grid>
    );
});

export default AddCustomerCancellationRuleSetStep1;